export default __webpack_public_path__ + "static/media/swift.facc57fe.svg";